import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { ReleaseModel } from '../../../models/dictionaries/release.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-releases-grid',
  template: `
<!-- Create Modal -->
<div class="modal" id="addReleaseModal">
        <div class="modal-dialog">
            <div class="form">
                <form class="form-group" [formGroup]="releaseForm" (ngSubmit)="saveNewRelease()">
                    <div class="modal-content">
    
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
    
                        <!-- Modal body -->
                        <div class="modal-body display-flex">
                            <div>
                                <div>
                                    <div class="display-flex">
                                        <span class="modal-label">Name:</span>
                                        <input type="text" [(ngModel)]="editedRelease.name"  formControlName="name">
                                    </div>
                                    <span>Release</span>
                                    <span style="padding-left: 4em"> Spring constant</span>
                                    <br>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isUxSet"  formControlName="isUxSet">
                                        <span class="modal-label">Ux</span>
                                        <span>Cux : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isUxSet" min="0" step="0.001"  formControlName="valueUx"
                                            [(ngModel)]="editedRelease.valueUx">
                                        <span>&ensp; [kN/m]</span>
                                    </div>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isUySet"  formControlName="isUySet">
                                        <span class="modal-label">Uy</span>
                                        <span>Cuy : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isUySet" min="0" step="0.001"  formControlName="valueUy"
                                            [(ngModel)]="editedRelease.valueUy">
                                        <span>&ensp; [kN/m]</span>
                                    </div>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isUzSet"  formControlName="isUzSet">
                                        <span class="modal-label">Uz</span>
                                        <span>Cuz : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isUzSet" min="0" step="0.001"  formControlName="valueUz"
                                            [(ngModel)]="editedRelease.valueUz">
                                        <span>&ensp; [kN/m]</span>
                                    </div>
                                    <span>Release</span>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isPhixSet"  formControlName="isPhixSet">
                                        <span class="modal-label">&phi;x</span>
                                        <span>C&phi;x : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhixSet" min="0" step="0.001"  formControlName="valuePhix"
                                            [(ngModel)]="editedRelease.valuePhix">
                                        <span>&ensp; [kNm/rad]</span>
                                    </div>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isPhiySet"  formControlName="isPhiySet">
                                        <span class="modal-label">&phi;y</span>
                                        <span>C&phi;y : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhiySet" min="0" step="0.001"  formControlName="valuePhiy"
                                            [(ngModel)]="editedRelease.valuePhiy">
                                        <span>&ensp; [kNm/rad]</span>
                                    </div>
                                    <div class="display-flex">
                                        <input type="checkbox" [(ngModel)]="editedRelease.isPhizSet"  formControlName="isPhizSet">
                                        <span class="modal-label">&phi;z</span>
                                        <span>C&phi;z : &ensp;</span>
                                        <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhizSet" min="0" step="0.001"  formControlName="valuePhiz"
                                            [(ngModel)]="editedRelease.valuePhiz">
                                        <span>&ensp; [kNm/rad]</span>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- Modal footer -->
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                            <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="releaseForm.invalid" (click)="saveNewRelease()">Save</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this release?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteRelease(editedRelease)">Delete</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="releaseForm">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="editedRelease.name"  formControlName="name">
                                </div>
                                <span>Release</span>
                                <span style="padding-left: 4em"> Spring constant</span>
                                <br>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isUxSet"  formControlName="isUxSet">
                                    <span class="modal-label">Ux</span>
                                    <span>Cux : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isUxSet" min="0" step="0.001"  formControlName="valueUx"
                                        [(ngModel)]="editedRelease.valueUx">
                                    <span>&ensp; [kN/m]</span>
                                </div>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isUySet"  formControlName="isUySet">
                                    <span class="modal-label">Uy</span>
                                    <span>Cuy : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isUySet" min="0" step="0.001"  formControlName="valueUy"
                                        [(ngModel)]="editedRelease.valueUy">
                                    <span>&ensp; [kN/m]</span>
                                </div>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isUzSet"  formControlName="isUzSet">
                                    <span class="modal-label">Uz</span>
                                    <span>Cuz : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isUzSet" min="0" step="0.001"  formControlName="valueUz"
                                        [(ngModel)]="editedRelease.valueUz">
                                    <span>&ensp; [kN/m]</span>
                                </div>
                                <span>Release</span>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isPhixSet"  formControlName="isPhixSet">
                                    <span class="modal-label">&phi;x</span>
                                    <span>C&phi;x : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhixSet" min="0" step="0.001"  formControlName="valuePhix"
                                        [(ngModel)]="editedRelease.valuePhix">
                                    <span>&ensp; [kNm/rad]</span>
                                </div>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isPhiySet"  formControlName="isPhiySet">
                                    <span class="modal-label">&phi;y</span>
                                    <span>C&phi;y : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhiySet" min="0" step="0.001"  formControlName="valuePhiy"
                                        [(ngModel)]="editedRelease.valuePhiy">
                                    <span>&ensp; [kNm/rad]</span>
                                </div>
                                <div class="display-flex">
                                    <input type="checkbox" [(ngModel)]="editedRelease.isPhizSet"  formControlName="isPhizSet">
                                    <span class="modal-label">&phi;z</span>
                                    <span>C&phi;z : &ensp;</span>
                                    <input class="insert-number" type="number" [disableControl]="!editedRelease.isPhizSet" min="0" step="0.001"  formControlName="valuePhiz"
                                        [(ngModel)]="editedRelease.valuePhiz">
                                    <span>&ensp; [kNm/rad]</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="releaseForm.invalid" (click)="editRelease()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addReleaseModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let release of releasesGridData, let row_no = index">
        <td>{{release.name}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(release, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(release, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`ng-katex{font-size:1.5em}table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px;margin-right:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.insert-number{width:120px}`]
})
export class ReleasesComponent implements OnInit {
  isReleasesHidden = true;
  releasesGridData: ReleaseModel[];
  templateRelease = new ReleaseModel();
  editedRelease = new ReleaseModel();
  releaseForm: FormGroup;
  rowNumber: number;
  headers: string[] = ['Name', ''];

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteReleaseSubject.subscribe((value) => {
      this.releasesGridData = this.releasesGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllReleases().subscribe((response) => {
      this.releasesGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  prepareCreate() {
    this.editedRelease = new ReleaseModel();
    this.createForm();
  }

  private createForm() {
    this.releaseForm = new FormGroup({
      name: new FormControl(this.editedRelease.name,
        Validators.required),
      isUxSet: new FormControl(this.editedRelease.isUxSet),
      valueUx: new FormControl(this.editedRelease.valueUx, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
      isUySet: new FormControl(this.editedRelease.isUySet),
      valueUy: new FormControl(this.editedRelease.valueUy, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
      isUzSet: new FormControl(this.editedRelease.isUzSet),
      valueUz: new FormControl(this.editedRelease.valueUz, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
      isPhixSet: new FormControl(this.editedRelease.isPhixSet),
      valuePhix: new FormControl(this.editedRelease.valuePhix, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
      isPhiySet: new FormControl(this.editedRelease.isPhiySet),
      valuePhiy: new FormControl(this.editedRelease.valuePhiy, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
      isPhizSet: new FormControl(this.editedRelease.isPhizSet),
      valuePhiz: new FormControl(this.editedRelease.valuePhiz, Validators.compose([Validators.min(0),
                                Validators.pattern('^\\d+(?:\\.\\d{1,3})?$')])),
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isReleasesHidden = !this.isReleasesHidden;
  }

  checkRealease(release: ReleaseModel) {
    if (!release.isUxSet) {
      release.valueUx = null;
    } else if ( release.valueUx === null){
      release.valueUx = 0;
    }
    if (!release.isUySet) {
      release.valueUy = null;
    } else if ( release.valueUy === null){
      release.valueUy = 0;
    }
    if (!release.isUzSet) {
      release.valueUz = null;
    } else if ( release.valueUz === null){
      release.valueUz = 0;
    }
    if (!release.isPhixSet) {
      release.valuePhix = null;
    } else if ( release.valuePhix === null){
      release.valuePhix = 0;
    }
    if (!release.isPhiySet) {
      release.valuePhiy = null;
    } else if ( release.valuePhiy === null){
      release.valuePhiy = 0;
    }
    if (!release.isPhizSet) {
      release.valuePhiz = null;
    } else if ( release.valuePhiz === null){
      release.valuePhiz = 0;
    }
  }

  saveNewRelease() {
    this.checkRealease(this.editedRelease);
    this.mainPageService.addNewReleaseIntoDb(JSON.stringify(this.editedRelease)).subscribe((response) => {
      this.editedRelease._id = response;
      this.releasesGridData.push(this.editedRelease);
      this.editedRelease = new ReleaseModel();
    });
  }

  setChoosenElement(element: ReleaseModel, row) {
    this.editedRelease = {
      ...element,
    };
    this.rowNumber = row;
  }

  editRelease() {
    this.checkRealease(this.editedRelease);
    console.log(this.releasesGridData[this.rowNumber]);
    Object.assign(this.releasesGridData[this.rowNumber], this.editedRelease);
    this.mainPageService.updateReleaseInDb(JSON.stringify(this.editedRelease)).subscribe(() => { });
  }

  deleteRelease(release) {
    this.mainPageService.removeRelease(release._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteReleaseSubject.next(release._id);
  }
}
